// extracted by mini-css-extract-plugin
export var notificationHost = "_fz-0";